export default __webpack_public_path__ + "static/media/learose2-1920w.247b7a47.avif";